import { render, staticRenderFns } from "./RedesignBaseCard.vue?vue&type=template&id=d409b546&scoped=true"
import script from "./RedesignBaseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignBaseCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RedesignBaseCard.vue?vue&type=style&index=0&id=d409b546&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d409b546",
  null
  
)

export default component.exports